import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'

import HeaderBar from 'common/components/HeaderBar'
import { withRouter } from '@piconetworks/router-adapter'

import { colors } from '@piconetworks/functions'
import Loader from 'common/modules/loader'

import xFrame from 'common/xFrame'

const InjectedHeaderBar = ({ router, ...rest }) => {
    const dispatch = useDispatch()
    const hideLogin = !!router?.query?.hideLogin
    const useDefault = !!router?.query?.useDefault
    const welcomeBack = !!router?.query?.welcomeBack

    const linkColor = useSelector(Loader.selectors.linkColor)
    const defaultPopup = useSelector(Loader.selectors.getDefaultPopup)
    const memberType = useSelector(() => Loader.selectors.memberType(defaultPopup))
    const isLoggedIn = !!useSelector(Loader.selectors.hasUserLoader)
    const userInitials = useSelector(Loader.selectors.userInitials)
    const userEmail = useSelector(Loader.selectors.userEmail)

    const onLoginButtonClick = () => {
        if (!welcomeBack) {
            xFrame.header.goToPromptLogin({
                dispatch,
                welcomeBack: !welcomeBack,
            })
        } else {
            xFrame.launcher.openDefaultPopup({ dispatch })
        }
    }

    const props = {
        ...rest,
        linkColor,
        contrastColor: colors.getContrastColor(linkColor),
        textColor: colors.getContrastColor(linkColor),
        memberType,
        isLoggedIn,
        userInitials,
        userEmail,
        hideLogin,
        useDefault,
        welcomeBack,
        onLoginButtonClick,
    }

    return <HeaderBar {...props} />
}

InjectedHeaderBar.propTypes = {
    router: PropTypes.any.isRequired,
}

export default React.memo(withRouter(InjectedHeaderBar))
